
define(
	'Code25.CaterpartsGlobal.CloseAccount.View'
	, [
		"Utils", "c25_closeAccount.tpl", "Profile.Model", "Tools", "Backbone", "Code25.CaterpartsGlobal.CloseAccount.Model"
	]
	, function (
		Utils, c25_closeAccount_tpl, ProfileModel, Tools, Backbone, Model
	) {
		'use strict';

		return Backbone.View.extend({

			template: c25_closeAccount_tpl,
			initialize: function (options) {

			},
			events: {
				'click [data-action="close-account"]': 'closeMyAccount',
			},
			closeMyAccount: function () {
				var self = this;
				Tools.showConfirmInModal(this.options.application, Utils.translate("Close my Account"), Utils.translate("Are you sure you want to close your account?"), function (res) {

					var model = new Model();

					model.fetch(
						{ data: {} }
					).done(function (result) {
						if (result.ok) {
							var logout = SC && SC.SESSION && SC.SESSION.touchpoints.logout;
							document.location = logout;
						} else {
							Tools.showErrorInModal(self.options.application, Utils.translate("Close my Account"), Utils.translate("Unable to close account. Please contact Caterparts support.") + "<br /><br />" + result.error);
						}
					}).catch(function (err) {
						Tools.showErrorInModal(self.options.application, Utils.translate("Close my Account"), Utils.translate("Unable to close account. Please contact Caterparts support.") + "<br />" + err);
					});



				}, Utils.translate("Yes"), Utils.translate("No"))
			},
			getBreadcrumbPages: function () {
				return {
					text: "Close Account",
					href: '/closeaccount'
				};
			},
			getContext: function getContext() {
				var profile = ProfileModel.getInstance();

				return { internalid: profile.get("internalid"), name: profile.get("name"), email: profile.get('email') };
			}
		});

	});
